import React from 'react';
import styled from 'styled-components';
import { Stack } from '@mui/material';
import { ReactComponent as DbtExpectationsIcon } from '../../assets/dbt-expectations-icon.svg';
import { ReactComponent as DbtIcon } from '../../assets/dbt-icon.svg';
import { ReactComponent as ElementaryIcon } from '../../assets/logo-black.svg';
import defaultdict from '../../utils/defaultdict';
import OverflowTooltip from '../OverflowTooltip';
import { fontSize } from '../../style/utils';

const Wrapper = styled(Stack)`
  > svg {
    path {
      fill: ${({ theme }) => theme.palette.icon.tertiary};
    }
  }
`;

const DbtIconStyled = styled(DbtIcon)`
  width: 12px;
  height: 12px;
  svg {
    width: 12px;
    height: 12px;
  }
`;

const ElementaryIconStyled = styled(ElementaryIcon)`
  width: 12px;
  height: 12px;
  > rect:first-child {
    fill: ${({ theme }) => theme.palette.icon.tertiary};
  }
`;

const anomalyDetectionIconMap = defaultdict(() => ElementaryIconStyled);
const schemaChangeIconMap = defaultdict(() => ElementaryIconStyled);
const dbtTestIconMap = defaultdict(() => DbtIconStyled, {
  expectation: DbtExpectationsIcon,
});

const typeIconMap = {
  anomaly_detection: anomalyDetectionIconMap,
  schema_change: schemaChangeIconMap,
  dbt_test: dbtTestIconMap,
  source_freshness: dbtTestIconMap,
  elementary_cloud: anomalyDetectionIconMap,
  pipeline_task_performance: anomalyDetectionIconMap,
} as any;

export const getTestIcon = (testType: string, testSubType: string) =>
  typeIconMap[testType]?.[testSubType];

export const testNameValueRenderer = (
  name: string,
  testType: string,
  testSubType: string,
) => (
  <Wrapper
    direction="row"
    sx={{ gap: 1, alignItems: 'center', fontSize: fontSize('base') }}
  >
    {React.createElement(getTestIcon(testType, testSubType) || (() => null))}
    <OverflowTooltip sx={{ flex: 1 }}>{name}</OverflowTooltip>
  </Wrapper>
);

const testNameRenderer = (value: any) =>
  testNameValueRenderer(
    value.metadata.test_name,
    value.metadata.test_type,
    value.metadata.test_sub_type,
  );

export default testNameRenderer;
